module.exports = __webpack_public_path__ + "static/media/23.856e91f8.jpeg";